import { Box, Container } from "@mui/material";
import React from "react";
import { Trading } from "../../CommonPage/MarketFlow/Trading";
import GlobalAssets from "../../Componenets/Globalassets/GlobalAssets";
import WhyTradeForex from "../../CommonPage/WhyTradeForexs/WhyTradeForex";
import { PickPairs } from "../../CommonPage/PickPair/PickPairs";
import { PickPairsStock } from "../../CommonPage/PickPair/PickPairsStock";
import Wealth from "../../Componenets/Globalassets/Wealth";
import NewWealth from "../../Componenets/Globalassets/NewWealth";
import NewCommonity from "../../Componenets/Globalassets/NewCommonity";
import { NewMetalsPairs } from "../../CommonPage/PickPair/NewMetalsPairs";
import { useLanguage } from "../../context/LanguageContext";
import GlobalForex from "../../Componenets/Globalassets/GlobalForex";
import GlobalStocks from "../../Componenets/Globalassets/GlobalStocks";

export const Shares = () => {
  const { language, translations } = useLanguage();
  const cardData = [
    {
      heading: translations[language]?.cardDataObj?.title1,
      logo: "/Images/share1.png",
      description: translations[language]?.cardDataObj?.description1,
    },
    {
      heading: translations[language]?.cardDataObj?.title2,
      logo: "/Images/share2.png",
      description: translations[language]?.cardDataObj?.description2,
    },
    {
      heading: translations[language]?.cardDataObj?.title3,
      logo: "/Images/share4.png",
      description: translations[language]?.cardDataObj?.description3,
    },
    {
      heading: translations[language]?.cardDataObj?.title4,
      logo: "/Images/share3.png",
      description: translations[language]?.cardDataObj?.description4,
    },
  ];

  const Commonity = [
    { name: "NTFX_Sh", spread: "1.2",img:"Images/netFlix.png", leverage: "1:100", lowSpread: "35:65",sub:"Netflix (NTFX.OQ)" },
    { name: "Apple_Sh", spread: "1.4",img:"Images/Appless.png", leverage: "1:100", lowSpread: "35:65",sub:"Apple (AAPL.OQ)" },
    { name: "TSLA_Sh", spread: "1.1",img:"/Images/four10.png",leverage: "1:100", lowSpread: "35:65",sub:"Tesla (TSLA.OQ)" },
    { name: "NVDA_Sh", spread: "1.2",img:"/Images/greeeen.png",leverage: "1:100", lowSpread: "35:65",sub:"NVIDIA (NDVA.OQ)" },
    { name: "GOOGL_Sh", spread: "1.4",img: "/Images/four2.png", leverage: "1:100", lowSpread: "35:65",sub:"Google (GOOGL.OQ)" },
    { name: "MSFT_Sh", spread: "1.1",img: "/Images/four5.png", leverage: "1:100", lowSpread: "35:65",sub:"Microsoft (MSFT.OQ)" },
    { name: "COLA_Sh", spread: "1.2",img:"Images/cola.png", leverage: "1:100", lowSpread: "35:65",sub:"Coco Cola (Cola.OQ)" },
    { name: "NIKE_Sh", spread: "1.2",img:"Images/nike.png", leverage: "1:100", lowSpread: "35:65",sub:"Nike (Nike.OQ)" },
    { name: "AMZN_Sh", spread: "1.2",img:"/Images/four7.png", leverage: "1:100", lowSpread: "35:65",sub:"Amazon (AMZN.OQ)" },
    { name: "META_Sh", spread: "1.2",img:"/Images/four4.png", leverage: "1:100", lowSpread: "35:65",sub:"Meta (Meta.OQ)" },
  ];

  return (
    <Box>
      <Trading
      banner="Images/forexClean5.png"
        titleLine1={translations[language]?.sharesTrading?.titleLine1}
        active={translations[language]?.sharesTrading?.active}
        titleLine2={translations[language]?.sharesTrading?.titleLine2}
        subtitle={translations[language]?.sharesTrading?.subtitle}
      />
      <GlobalStocks />
      <WhyTradeForex
        subtitle={translations[language]?.ClainT}
        cardData={cardData}
      />
      <PickPairsStock
        Commonity={Commonity}
        title={translations[language]?.shareTitle}
        subtitle={translations[language]?.shareTitleDes}
      />
      {/* <PickPairsStock Commonity={Commonity} title="Pick Your Commodities" subtitle="You can see all trading hours in the Members Area." /> */}
      <Container maxWidth="xl">

      <Box mt={10} mx={7}>
        <NewCommonity
          title={
            <>
              {translations[language]?.shareCom} <br />
              {translations[language]?.shareCom1}
            </>
          }
          subtitle={
            <>
              {translations[language]?.shareComDes}
              <br /> {translations[language]?.shareComDes1}
            </>
          }
        />
      </Box>
      </Container>
    </Box>
  );
};
//
